/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import BulmaColumns from 'react-bulma-components/lib/components/columns';
import BulmaContainer from 'react-bulma-components/lib/components/container';
import BulmaSection from 'react-bulma-components/lib/components/section';

import { css } from '@emotion/core';

import { Heading, LazyImage, TextLink } from '../atoms';
import { createRandomId } from '../../util/createRandomId';

import {
  styledAnimations,
  styledContainerHeading,
  styledContentWrapper,
  styledContentColumn,
  styledHeading,
  styledImagesContent,
  styledLink,
  styledSubheading,
} from './ImagesContentBandStyles';

const renderHeading = (text, atts, headingCss) => (
  <Heading {...atts} css={headingCss}>
    {text.text}
  </Heading>
);

const ImagesContentBand = ({ input }) => {
  const {
    background_color,
    heading,
    heading_color,
    subheading,
    subheading_color,
    background_image,
    content_title,
    content_title_color,
    content_text,
    content_text_color,
    content_link,
    content_link_text,
    content_link_color,
    row_reverse,
  } = input.primary;

  return (
    <BulmaSection
      id="testImagesContentBand"
      css={styledImagesContent}
      style={{
        backgroundColor: background_color || '#fff',
        backgroundImage: `url(${background_image ? background_image.url : ''})`,
        paddingTop: heading && heading[0].text && '120px',
        paddingBottom: input.fields.length <= 1 && !heading && '0px',
      }}
    >
      {heading || subheading ? (
        <BulmaContainer css={styledContentWrapper} style={{ marginTop: !heading && '0px' }}>
          {heading && heading[0].text
            ? renderHeading(
                heading[0],
                {
                  renderAs: 'h2',
                  className: 'h2',
                  style: { color: heading_color, paddingBottom: '120px' },
                },
                css`
                  ${styledContainerHeading}
                  ${styledHeading}
                `,
              )
            : null}
          {subheading && subheading[0].text
            ? renderHeading(
                subheading[0],
                {
                  renderAs: 'p',
                  className: 'medium',
                  style: { color: subheading_color },
                  subtitle: true,
                },
                css`
                  ${styledSubheading}
                  ${styledHeading}
                `,
              )
            : null}
        </BulmaContainer>
      ) : null}
      <BulmaContainer style={{ marginTop: !heading && '64px' }}>
        <BulmaColumns style={row_reverse ? { flexDirection: 'row-reverse' } : { flexDirection: 'row' }}>
          <BulmaColumns.Column css={styledAnimations}>
            {input.fields.map(item => (
              <LazyImage
                alt={item.image.alt}
                className={item.image.alt && item.image.alt.replace(/ /g, '')}
                src={item.image.url}
              />
            ))}
          </BulmaColumns.Column>
          <BulmaColumns.Column css={styledContentColumn}>
            {content_title &&
              content_title[0].text &&
              renderHeading(
                content_title[0],
                {
                  className: 'h3',
                  renderAs: 'h3',
                  style: { color: content_title_color, marginTop: '0px' },
                  'data-testid': 'images_content_band_title',
                },
                styledHeading,
              )}

            {content_text &&
              content_text[0].text &&
              content_text.map(cT =>
                renderHeading(cT, {
                  renderAs: 'p',
                  className: 'medium subtitle',
                  style: { color: content_text_color || null },
                  key: createRandomId(),
                }),
              )}
            {content_link && content_link_text ? (
              <TextLink
                data-testid="images_content_band_text_link"
                css={styledLink}
                url={content_link && content_link.url}
                style={{ color: content_link_color }}
                className="arrow"
              >
                {content_link_text && content_link_text[0].text}
              </TextLink>
            ) : null}
          </BulmaColumns.Column>
        </BulmaColumns>
      </BulmaContainer>
    </BulmaSection>
  );
};

export default ImagesContentBand;

ImagesContentBand.propTypes = {
  input: PropTypes.object.isRequired,
};
